export default {"src":"/_next/static/media/SOC2-type2-certified.bb66f4f2.svg","height":1600,"width":1600};